import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useRef } from 'react';
import { RequiredAsterisk, InputLabel, InputWrapper, TextInput, InputErrorMessage, IconTextInputWrapper, } from './BKJDollarTextInput.styled.js';
import { mergeRefs } from '../BKJSelect/utils/mergeRefs.js';
export const BKJDollarTextInput = forwardRef((props, ref) => {
    const { label, error, disabled, required, className, onChange, value, max, ...rest } = props;
    const innerRef = useRef({ focus: () => null, value: '' });
    const handleOuterFocus = useCallback(() => {
        innerRef && innerRef.current && innerRef.current.focus();
    }, []);
    const handleBlur = useCallback((e) => {
        const currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        let val = Number.parseFloat(e.target.value.replace(/[^0-9.-]+/g, ''));
        let maskedValue = '';
        if (e.target.value !== '' && !Number.isNaN(val)) {
            if (max)
                val = Math.min(val, max);
            maskedValue = currencyFormatter.format(val);
        }
        if (onChange) {
            onChange({ ...e, target: { value: maskedValue } });
        }
    }, [onChange, max]);
    const handleChange = useCallback((e) => {
        if (onChange) {
            onChange({ ...e, target: { value: e.target.value } });
        }
    }, [onChange]);
    const hasValue = value !== '';
    return (_jsxs(IconTextInputWrapper, { className: className, tabIndex: -1, onFocus: handleOuterFocus, children: [label && (_jsxs(InputLabel, { disabled: disabled, children: [label, required && _jsx(RequiredAsterisk, { children: "\u00A0*" })] })), _jsx(InputWrapper, { children: _jsx(TextInput, { placeholder: "None", onBlur: handleBlur, ref: mergeRefs([ref, innerRef]), error: error ? (Array.isArray(error) ? !!error.length : !!error) : false, disabled: disabled, value: value, hasValue: hasValue, onChange: handleChange, max: max, ...rest }) }), error && Array.isArray(error) ? (error.map((err) => _jsx(InputErrorMessage, { children: err }, err))) : (_jsx(InputErrorMessage, { children: error }))] }));
});
//# sourceMappingURL=BKJDollarTextInput.js.map